import { useGetBuyerContactData } from '@/hooks/buyers/useGetBuyerContactData';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { BuyerProfileUi, initialState } from './BuyerProfileUi';

export function useBuyerProfileViewController() {
  const { buyerId } = useParams();
  const [uiState, setUiState] = useImmer<BuyerProfileUi>(initialState);
  const { data } = useGetBuyerContactData(buyerId);

  useEffect(() => {
    if (!data) return;
    setUiState((draft) => {
      draft.title = data.name;
    });
  }, [data, setUiState]);

  return {
    uiState: {
      ...uiState,
      buyerId,
    },
  };
}
